import { RefreshCw } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { cn } from "../../../../lib/utils";

// Shared chrome for every queue page: eyebrow + title + refresh + status tabs.
// Forex owns most of them, hence the default, but the Ginox KYC page uses it too.
export function QueueLayout({
  eyebrow = "Forex",
  title,
  accent,
  description,
  statusOptions,
  status,
  onStatus,
  isFetching,
  onRefresh,
  children,
}) {
  return (
    <div className="space-y-8">
      <header className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
        <div className="min-w-0">
          <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            <span className="h-px w-6 bg-ginox-green" />
            {eyebrow}
          </div>
          <h1 className="mt-3 break-words font-serif text-[40px] italic leading-[1.02] tracking-tightest text-foreground sm:text-[48px]">
            {title} {accent ? <span className="text-gradient-ginox">{accent}</span> : null}
          </h1>
          {description ? (
            <p className="mt-3 max-w-xl text-sm text-muted-foreground">{description}</p>
          ) : null}
        </div>

        <Button variant="outline" size="sm" onClick={onRefresh}>
          <RefreshCw className={cn("h-3.5 w-3.5", isFetching && "animate-spin")} />
          Refresh
        </Button>
      </header>

      {statusOptions ? (
        <div className="flex flex-wrap gap-1.5">
          {statusOptions.map((opt) => (
            <button
              key={opt.value}
              type="button"
              onClick={() => onStatus(opt.value)}
              className={cn(
                "rounded-md border px-3 py-1.5 text-xs font-medium transition-colors",
                status === opt.value
                  ? "border-ginox-green/60 bg-ginox-green/10 text-ginox-green"
                  : "border-border/70 bg-white/[0.02] text-muted-foreground hover:text-foreground",
              )}
            >
              {opt.label}
            </button>
          ))}
        </div>
      ) : null}

      {children}
    </div>
  );
}
